<template>
  <v-container>
    <v-row v-if="product">
      <v-col>
        <v-card class="d-flex align-center justify-center flex-column pa-5">
          <v-card-text>
            <v-list dense disabled>
            <v-list-item-group class="d-flex  flex-column justify-center">
              <v-list-item class="my-4"  style="border: none;" v-if="this.product.product_code">
                <v-list-item-icon>
                  <v-avatar color="#def6ff" size="30" class="icon-box">
                    <v-icon small color="#00B3FF">double_arrow</v-icon>
                  </v-avatar>
                </v-list-item-icon>
                <v-row>
                  <v-col  xs="12" md="4" class="detail-label">Product Code</v-col>
                  <v-col  xs="12" md="8" class="detail-value">{{ this.product.product_code }}</v-col>
                </v-row>
              </v-list-item>
              <v-divider class="border-opacity-25"></v-divider>
              <v-list-item class="my-4"  style="border: none;">
                <v-list-item-icon>
                  <v-avatar color="#def6ff" size="30" class="icon-box">
                    <v-icon small color="#00B3FF">double_arrow</v-icon>
                  </v-avatar>
                </v-list-item-icon>
                <v-row>
                  <v-col  xs="12" md="4" class="detail-label">Product Name</v-col>
                  <v-col  xs="12" md="8" class="detail-value">{{ this.product.name }}</v-col>
                </v-row>
              </v-list-item>
              <v-divider class="border-opacity-25"></v-divider>
              <v-list-item class="my-4" style="border: none;">
                <v-list-item-icon>
                  <v-avatar color="#def6ff" size="30" class="icon-box">
                    <v-icon small color="#00B3FF">double_arrow</v-icon>
                  </v-avatar>
                </v-list-item-icon>
                <v-row>
                  <v-col xs="12" md="4" class="detail-label">Unit Price</v-col>
                  <v-col xs="12" md="8" class="detail-value">{{ this.product.product_price.retail_price }}</v-col>
                </v-row>
              </v-list-item>
              <v-divider class="border-opacity-25"></v-divider>
              <v-list-item class="my-4" style="border: none;">
                <v-list-item-icon>
                  <v-avatar color="#def6ff" size="30" class="icon-box">
                    <v-icon small color="#00B3FF">double_arrow</v-icon>
                  </v-avatar>
                </v-list-item-icon>
                <v-row >
                  <v-col xs="12" md="4" class="detail-label">Unit Cost</v-col>
                  <v-col xs="12" md="8" class="detail-value">{{ this.product.product_price.cost }}</v-col>
                </v-row>
              </v-list-item>
              <v-divider class="border-opacity-20"></v-divider>
              <v-list-item class="my-4" style="border: none;">
                <v-list-item-icon>
                  <v-avatar color="#def6ff" size="30" class="icon-box">
                    <v-icon small color="#00B3FF">double_arrow</v-icon>
                  </v-avatar>
                </v-list-item-icon>
                <v-row >
                  <v-col xs="12" md="4" class="detail-label">Unit</v-col>
                  <v-col xs="12" md="8" class="detail-value">{{ this.product.product_unit.name }}</v-col>
                </v-row>
              </v-list-item>
              <v-divider class="border-opacity-20"></v-divider>
              <v-list-item class="my-4" style="border: none;">
                <v-list-item-icon>
                  <v-avatar color="#def6ff" size="30" class="icon-box">
                    <v-icon small color="#00B3FF">double_arrow</v-icon>
                  </v-avatar>
                </v-list-item-icon>
                <v-row>
                  <v-col xs="12" md="4" class="detail-label">Reorder Level</v-col>
                  <v-col xs="12" md="8" class="detail-value"> {{ this.product.reorder_level }}</v-col>
                </v-row>
              </v-list-item>
            </v-list-item-group>
          </v-list>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col>
        <v-alert type="info">No product information available.</v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

  
  
  <script>
  import { filters } from "../../utility/filters";
  import { ProductService } from "@/services/product-service";
  import { checkError } from "@/config/errors.js";
  
  export default {
    name: "ProductInfo",
    data() {
      return {
        product: {},
        loading: false,
        defaultImage: require("@/assets/img/avatar.svg"),
      };
    },
  
    mounted() {
      this.$store.dispatch("auth/getProfile");
      this.getProductInfo();
    },
  
    methods: {
      getProductInfo() {
        this.loading = true;
        ProductService.getProductInfo(this.$route.params.uuid)
          .then((response) => {
            this.loading = false;
            if (response.data.data) {
              console.log(response.data.data);
              this.product = response.data.data;
            }
          })
          .catch((error) => {
            this.loading = false;
            this.product = {};
            let data = error.response.data;
            let errorOutput = checkError.errorFormatting(data);
            this.errors = errorOutput;
          });
      },

      getProfileColor(letter) {
        return filters.getProfileColor(letter);
      },
    },
  };
  </script>
  <style>
  .profile-avatar {
    text-align: center;
    padding: 5px;
  }
  
  .profile-avatar .v-card__title {
    align-items: center;
    display: grid;
    flex-wrap: wrap;
    font-size: 1.25rem;
    font-weight: 500;
    letter-spacing: 0.0125em;
    line-height: 2rem;
    word-break: break-all;
  }
  
  .icon-box{
      border-radius: 30%;
    }
    .detail-label {
      font-weight: 500;
      color: black;
    }
    .detail-value {
      color: #555;
      font-weight:400;
    }
  
  </style>
  